import initReactApp from 'dpl/util/initReactApp';
import ShelterResultsPageContainer from 'dpl/shelter_search_results/containers/ResultsPageContainer';
import ShelterDetailsDogModalContainer from 'dpl/shelter_search_results/containers/DetailsDogModalContainer';

initReactApp({
  ShelterResultsPageContainer,
  ShelterDetailsDogModalContainer
});
